module.exports = __webpack_public_path__ + "icons_03.06cd36eb.svg";